import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'activityBuyer', method: 'GET', body: null, token: token })
}
